module.exports = __webpack_public_path__ + "img/logo1 (4).a7649fcf.jpg";